<script async setup>
import { useAdminRoles } from "~/composables/permissions/adminRoles"

const { isAdminRole, isCoordinatorRole } = await useAdminRoles()
</script>

<template>
	<v-navigation-drawer permanent app>
		<v-list>
			<v-list density="compact" nav>
				<v-list-item prepend-icon="mdi-file-multiple" title="Projects" value="projects">
					<NuxtLink to="/admin/projects">Projects</NuxtLink>
				</v-list-item>

				<v-list-item
					prepend-icon="mdi-account-multiple"
					title="Coordinators"
					value="managers"
				>
					<NuxtLink to="/admin/managers">Coordinators</NuxtLink>
				</v-list-item>

				<v-list-item
					prepend-icon="mdi-account-multiple"
					title="Form Templates"
					value="admin-forms"
				>
					<NuxtLink to="/admin/forms">Forms</NuxtLink>
				</v-list-item>

				<v-list-item prepend-icon="mdi-tag-multiple" title="Tags" value="tags">
					<NuxtLink to="/admin/tags">Tags</NuxtLink>
				</v-list-item>

				<v-list-item
					prepend-icon="mdi-arrow-up-circle"
					title="Follow Ups"
					value="followups"
				>
					<NuxtLink to="/admin/followups">Follow-ups</NuxtLink>
				</v-list-item>

			</v-list>
		</v-list>
	</v-navigation-drawer>
</template>
